/**
 * Transforms GitHub PR URLs to cubic.dev URLs
 *
 * @example
 * // Input
 * const url = 'https://github.com/mrge-io/mrge/pull/255';
 *
 * // Output
 * transformGitHubPRUrl(url); // 'https://cubic.dev/pr/mrge-io/mrge/pull/255'
 */
export function transformGitHubPRUrl(url: string): string {
  const githubPRRegex = /https:\/\/github\.com\/([^/]+)\/([^/]+)\/pull\/(\d+)/;
  const match = url.match(githubPRRegex);

  if (!match) {
    return url;
  }

  const [, owner, repo, prNumber] = match;
  return `https://cubic.dev/pr/${owner}/${repo}/pull/${prNumber}`;
}
